import React from "react";
import ReactTags from "react-tag-autocomplete";

export default class UserTags extends React.Component {
    state = {
        tags: this.props.user.tags,
        tag_suggestions: this.props.tags
    };

    componentDidMount() {
        this.inputRef = React.createRef();
        // let tags = [];

        // if (this.props.user.tags !== undefined) {
        //     this.props.user.tags.forEach(tag => {
        //         tags.push({id: tag.slug, name: tag.tag}); 
        //     });
        // }

        // this.setState({tags});
    }

    onDelete(i) {
        const tags = this.state.tags.slice(0);
        tags.splice(i, 1);
        this.setState({ tags }, () => {
            this.props.updateUser(this.props.user);
        });

        tags.map((tag) => {
            tag.tag = tag.name;
            return tag;
        });

        this.props.toggleCell(this.props.user.customerId, 'tags', tags);
    }

    onAddition(tag) {

        const tags = [].concat(this.state.tags, tag);
        this.setState({ tags }, () => {
            this.props.updateUser(this.props.user);
        });

        tags.map((tag) => {
            tag.tag = tag.name;
            return tag;
        });
        
        this.props.toggleCell(this.props.user.customerId, 'tags', tags);
    }

    render() {
        return (
            <React.Fragment>
                <form autoComplete="off" className="form form--horizontal" >
                    <ReactTags
                        ref={this.inputRef}
                        tags={this.props.user.tags}
                        allowNew={true}
                        suggestions={this.props.tags}
                        onDelete={this.onDelete.bind(this)}
                        onAddition={this.onAddition.bind(this)} 
                        placeholderText="Add to List" 
                        addOnBlur={true} 
                    />
                </form>
            </React.Fragment>
        );
    }
}